export default "__VITE_ASSET__ML$$Wr6F__"